import axios from 'axios'
import { useMessagesStore } from '../stores/messages'


axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    // Validación mejorada del token
    if (token && token !== 'null' && token !== 'undefined' && token !== '') {
        config.headers.Authorization = 'Bearer ' + token;
    }
    // Siempre pedir JSON para que Laravel no haga redirects 302
    config.headers.Accept = 'application/json';
    // En desarrollo, usar rutas relativas para que funcione el proxy de Vite
    // En producción, usar la URL configurada
    if (import.meta.env.DEV) {
        // En desarrollo, usar rutas relativas para el proxy
        config.baseURL = '';
    } else {
        // En producción, usar la URL configurada
        config.baseURL = import.meta.env.VITE_APP_BASE_URL;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    if (response.data.code === 201) {
      const messagesStore = useMessagesStore();
      messagesStore.showSuccess(response.data.message);
    }
    return response;
}, (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Solo eliminar token si NO es una petición de usuario autenticado
        // Las rutas de API de usuario pueden devolver 401 temporalmente
        const isUserEndpoint = error.config.url && (
          error.config.url.includes('/api/users/me') ||
          error.config.url.includes('/api/me')
        );
        
        if (!isUserEndpoint) {
          console.log("Token inválido, redirigiendo al login");
          // El token ya no sirve: no hay nada que revocar en el servidor, solo
          // que limpiar. Se hace acá y no con meStore.clearSession() para no
          // importar el store desde el módulo que él mismo importa.
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('permissions');
          localStorage.removeItem('expired');
          // Redirigir al login solo si no estamos ya ahí
          if (!window.location.pathname.includes('/auth/login')) {
            window.location.href = '/auth/login';
          }
        } else {
          console.log("Error temporal obteniendo usuario, manteniendo sesión");
        }
      }
      if (error.response.status === 422) {
        // No mostrar errores 422 del login (Login.vue los maneja)
        const isLoginRequest = error.config.url && error.config.url.includes('/login');
        if (!isLoginRequest) {
          const messagesStore = useMessagesStore();
          // Los rechazos del comprobante traen `message` y no `errors`: sin
          // este respaldo el toast salía vacío.
          messagesStore.showError(
            error.response.data.errors || error.response.data.message
          );
        }
      }
      if (error.response.status >= 500) {
        const messagesStore = useMessagesStore();

        /*
         * Un fallo del servidor y un rechazo del comprobante llegan los dos por
         * acá, y no dicen lo mismo.
         *
         * Cuando el backend no pudo emitir —ARCA lo rechazó, faltaba un dato
         * fiscal— manda `success: false` con el motivo en `message`, y ese
         * motivo es lo único que le sirve a quien está facturando: "el CUIT del
         * receptor no es válido" se corrige, "ocurrió un error en el servidor"
         * no. Hoy eso viene con un HTTP 200 —el `catch` de `store()` no pasa
         * status—, así que este camino se activa recién cuando se corrija; hasta
         * entonces no cambia nada.
         *
         * El genérico queda para lo que de verdad es un error nuestro, que no
         * trae `success` y cuyo `message` en producción es "Server Error".
         * Sin esto, un fallo del servidor no le llegaba al usuario: la pantalla
         * simplemente quedaba vacía. Pasó con los 500 por permisos de storage,
         * donde 17 peticiones fallaron sin un solo aviso.
         */
        const cuerpo = error.response.data;

        if (cuerpo && cuerpo.success === false && cuerpo.message) {
          messagesStore.showError(cuerpo.message);
        } else {
          messagesStore.showError(
            'Ocurrió un error en el servidor. Si continúa, avisá a soporte.'
          );
        }
      }
      // Importante: Rechazar la promesa para que el guard pueda manejarlo
      return Promise.reject(error);
    }
    // Si no hay response, la petición nunca llegó a destino (red caída,
    // timeout, CORS o una redirección a un host inalcanzable). Antes solo
    // quedaba en la consola y el listado se mostraba vacío, como si no
    // hubiera datos.
    console.error('Network error:', error.message);
    const messagesStore = useMessagesStore();
    messagesStore.showError(
      'No se pudo conectar con el servidor. Revisá tu conexión e intentá de nuevo.'
    );
    // Rechazar la promesa para mantener el flujo de errores
    return Promise.reject(error);
});

export default axios